import { Deal } from '../types/deal';
import apiClient from './apiClient';

export type DealDto = Deal;

const dealsService = {
  list: async (): Promise<DealDto[]> => {
    const { data } = await apiClient.get<{ deals: DealDto[] }>('/api/deals');
    return data.deals || [];
  },

  get: async (id: string): Promise<DealDto> => {
    const { data } = await apiClient.get<{ deal: DealDto }>(`/api/deals/${id}`);
    return data.deal;
  },

  create: async (payload: Partial<Deal>): Promise<DealDto> => {
    const { data } = await apiClient.post<{ deal: DealDto }>('/api/deals', payload);
    return data.deal;
  },

  update: async (id: string, patch: Partial<Deal>): Promise<DealDto> => {
    const { data } = await apiClient.patch<{ deal: DealDto }>(`/api/deals/${id}`, patch);
    return data.deal;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/api/deals/${id}`);
  },

  importLocal: async (deals: Deal[]): Promise<DealDto[]> => {
    const { data } = await apiClient.post<{ deals: DealDto[] }>('/api/deals/import', { deals });
    return data.deals || [];
  },
};

export default dealsService;
